<mat-card>
  <h2 translate>formationDocumentation.card.title</h2>
  <mat-card-content>
    <p translate>formationDocumentation.card.subtitle</p>
  </mat-card-content>
</mat-card>

<div class="documentation-formation__container">
  <scf-formation-data-item
    *ngFor="let item of data"
    [isAutos]="isAuto"
    [isConsumption]="isConsumption"
    [element]="item"
  ></scf-formation-data-item>
</div>
